import React, { useEffect, useRef } from 'react';
import { ParticlesContainer, Particle } from './ParticlesBackground.styles';

const ParticlesBackground = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Create particles
    const particleCount = 50;
    const particles = [];

    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement('div');
      particle.className = 'floating-particle';
      
      // Random positioning
      particle.style.left = Math.random() * 100 + '%';
      particle.style.top = Math.random() * 100 + '%';
      
      // Random animation delay and duration
      particle.style.animationDelay = Math.random() * 20 + 's';
      particle.style.animationDuration = (Math.random() * 10 + 15) + 's';
      
      // Random size
      const size = Math.random() * 4 + 2;
      particle.style.width = size + 'px';
      particle.style.height = size + 'px';
      
      container.appendChild(particle);
      particles.push(particle);
    }

    // Cleanup function
    return () => {
      particles.forEach(particle => {
        if (particle.parentNode) {
          particle.parentNode.removeChild(particle);
        }
      });
    };
  }, []);

  return (
    <ParticlesContainer ref={containerRef}>
      {/* Static decorative particles for immediate visibility */}
      <Particle delay="0s" size="3px" left="10%" top="20%" />
      <Particle delay="2s" size="2px" left="80%" top="30%" />
      <Particle delay="4s" size="4px" left="60%" top="70%" />
      <Particle delay="6s" size="2px" left="20%" top="80%" />
      <Particle delay="8s" size="3px" left="90%" top="60%" />
    </ParticlesContainer>
  );
};

export default ParticlesBackground;
